import { Component, OnInit, Directive, HostListener } from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';


@Component({
  selector: 'app-status-info',
  templateUrl: './status-info.component.html',
  styleUrls: ['./status-info.component.css']
})


export class StatusInfoComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  Data:any = []
  statusData: any = []
  
  singleStatusMaster: any= []
  deleteUomMasterId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid:any

  statusTypes = [
    'MDSTATUS'
  ]
  isLoading: any = false


  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  // @HostListener('click', ['$event.target'])
  //   clickEvent(event) {
  //       event.preventDefault();
  //       event.stopPropagation();
  //       event.currentTarget.disabled = true;
  //   }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action
  
    this.cid = sessionStorage.getItem('cid')
    this.getAllStatusMaster()
    this.form = this.fb.group({
      name: [''],
      description: [''],
      type:[''],
    })
    this.editForm = this.fb.group({
      name: [''],
      description: [''],
      type:[''],
    })
   
  }

  onTableDataChange(event: any) {
    this.page = event.page+1;
  }

  addStatus(){
    //document.getElementById("submit").disabled = true;
    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "name": String(this.form.get('name').value),
      "type": String(this.form.get('type').value),
      "cid": this.cid
    }
    
    console.log(body)
    this.generic_service.addStatusMaster(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllStatusMaster()
        this.cancelModel()
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllStatusMaster(){
    this.isLoading = true

    this.generic_service.getAllStatusMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.statusData = res.response
        this.count = res.response.length
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


// form.submit(function(){
//     form.submit(function(){
//         return false;
//     });
// });

  getStatusMasterById(id:any){
    this.generic_service.getStatusMasterById(id).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleStatusMaster = []
        this.singleStatusMaster.push(res.response)
        this.editForm.patchValue({
          name: res.response.name,
          type: res.response.type,
          description: res.response.description,
        })
        console.log(this.editForm.value)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  } 
}

